module.exports = __webpack_public_path__ + "img/57.89bdf9ed.jpg";